import { Component, OnInit } from '@angular/core';
import { SubscriptionForRegister } from 'src/app/_models/SubscriptionForRegister';
import { AdminServiceService } from 'src/app/_services/AdminService.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ActivatedRoute } from '@angular/router';
import { AlertifyService } from '../_services/alertify.service';
import { AuthServiceService } from '../_services/AuthService.service';


@Component({
  selector: 'app-emailapi',
  templateUrl: './emailapi.component.html',
  styleUrls: ['./emailapi.component.css']
})
export class EmailapiComponent implements OnInit {

  emailContent: any;
  projects: any = new Array<any>();
  currentSubscription: SubscriptionForRegister = new SubscriptionForRegister();
  currentApiKey: any;
  currentEmailConfig: any;

  constructor(private _adminService: AdminServiceService, private _route: ActivatedRoute, 
    private _alertify: AlertifyService, private _authService: AuthServiceService) { }

  jwtHelper = new JwtHelperService();
  decodedToken: any;
  apiInfo: any;
  
  ngOnInit() {
    this._route.queryParams.subscribe(params => {
      this.loadApiInfo(params["id"]);
    });    
    
    this.loadProjects();
  }

  onAddNewProject() {
    this.projects.push(this.currentSubscription);
  }

  private loadApiInfo(apiId) {
    this._adminService.getApiDetails(apiId).subscribe(details => {
      this.apiInfo = details;
    }, error => {
      this._alertify.error(error);
    });
  }

  loadProjects() {
    console.log('Loading Projects...', this._authService.decodedToken.nameid);
    this._adminService.getSubscriptionsByUserId(this._authService.decodedToken.nameid).subscribe(data => {
      console.log('Projects loaded:', data);
      this.projects = data;
    });
  }

}




      
      
